import ClevertapReact from './cleverTap.utils';

export const ctLog = ({
  eventName = '',
  eventCategory = '',
  eventDescription = '',
  extraData = {},
}) => {
  const ctData = {
    'Event Name': eventName,
    'Event Category': eventCategory,
    'Event Description': eventDescription,
    'Event Date': new Date(),
    isPwa: true,
    ...extraData,
  };
  try {
    ClevertapReact.event(eventName, ctData);
  } catch (err) {
    console.warn('err', err);
  }
};

export const ctLogV2 = ({
  eventName = '',
  eventCategory = '',
  eventDescription = '',
  customerId,
  extraData = {},
}) => {
  const commonData = {
    Identity: customerId,
  };

  const ctData = {
    'Event Name': eventName,
    'Event Category': eventCategory,
    'Event Description': eventDescription,
    'Event Date': new Date(),
    ...commonData,
    ...extraData,
  };
  try {
    ClevertapReact.event(eventName, ctData);
  } catch (err) {
    console.warn('err', err);
  }
};
